import { render } from "./authorityManage.vue?vue&type=template&id=1de11d8a&scoped=true"
import script from "./authorityManage.vue?vue&type=script&lang=js"
export * from "./authorityManage.vue?vue&type=script&lang=js"

import "./authorityManage.vue?vue&type=style&index=0&id=1de11d8a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1de11d8a"]])

export default __exports__